<app-header></app-header>
<div class="settings-container">
  <div class="settings-section">
    <div class="section-title">
      <i class="ph-fill ph-user"></i>
      @if (name) {
        <span>{{ name }}</span>
      } @else {
        <span>{{ 'settings.my-settings' | translate }}</span>
      }
    </div>
    <div class="input-container">
      <label for="job-input">{{ 'job-description.modal-input-label' | translate }}</label>
      <input
        id="job-input"
        type="text"
        placeholder="{{ 'job-description.modal-input-placeholder' | translate }}"
        maxlength="1024"
        [(ngModel)]="role"
      />
    </div>
    <div>
      <ex-button
        type="primary"
        variant="raised"
        (click)="saveRole()"
        [disabled]="role.trim().length === 0 || user?.jobDescription === role.trim()"
      >
        {{ 'common.save' | translate }}
      </ex-button>
    </div>
  </div>
  <div class="settings-section">
    <div class="section-title">
      <i class="ph-fill ph-lock-key"></i>
      <span>{{ 'settings.security' | translate }}</span>
    </div>
    @if (!hasPassword) {
      <div class="create-password-container">
        <p class="create-password-description">{{ 'settings.create-password-description' | translate }}</p>
        @if (passwordEmailSent) {
          <div class="create-password-sent">
            <i class="ph ph-check-circle"></i>
            <span>{{ 'settings.create-password-sent' | translate }}</span>
          </div>
        } @else {
          <ex-button type="primary" variant="raised" (click)="createPassword()" [disabled]="creatingPassword">
            {{ 'settings.create-password-button' | translate }}
          </ex-button>
        }
      </div>
    } @else {
      <div class="password-container">
        <form [formGroup]="formOldPassword" autocomplete="off">
          <div class="form-group">
            <label for="oldPassword" class="login-label-title fw-bold"> {{ 'update-password.actual' | translate | uppercase }}</label>

            <div class="input-group">
              <input
                id="oldPassword"
                class="form-control"
                formControlName="oldPassword"
                [type]="fieldTextTypeList[0] ? 'text' : 'password'"
                (blur)="onSubmitOldPassword()"
                (focus)="userLeftInputPreviousPassword = false"
                [ngClass]="{ 'is-invalid': oldPasswordIsWrong && userLeftInputPreviousPassword }"
              />
              <div class="input-group-append-hide-show">
                <span *ngIf="fieldTextTypeList[0]" (click)="toggleFieldTextType(0)" class="hide-show">
                  <img class="hide-show-icon" src="/assets/images/hide-password-icon.svg" alt="icon-hide" />
                </span>
                <span *ngIf="!fieldTextTypeList[0]" (click)="toggleFieldTextType(0)" class="hide-show">
                  <img class="hide-show-icon" src="/assets/images/show-password-icon.svg" alt="icon-show" />
                </span>
              </div>
            </div>
            <div *ngIf="oldPasswordIsWrong && userLeftInputPreviousPassword" class="error-div">
              <div class="no-match-error-message">
                <img class="no-match-icon" src="/assets/images/icon-alert-triangle.svg" alt="icon-alert-triangle" />
                <div class="no-match-text">{{ 'update-password.invalid-previous-password' | translate }}</div>
              </div>
            </div>
          </div>
        </form>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="form-group new-password-form-group">
            <label for="newPassword" class="login-label-title fw-bold">
              {{ 'update-password.enter-new-password' | translate | uppercase }}</label
            >

            <div class="input-group">
              <input
                id="newPassword"
                [type]="fieldTextTypeList[1] ? 'text' : 'password'"
                formControlName="newPassword"
                class="form-control"
              />
              <div class="input-group-append-hide-show">
                <span *ngIf="fieldTextTypeList[1]" (click)="toggleFieldTextType(1)" class="hide-show">
                  <img class="hide-show-icon" src="./assets/images/hide-password-icon.svg" alt="icon-hide" />
                </span>
                <span *ngIf="!fieldTextTypeList[1]" (click)="toggleFieldTextType(1)" class="hide-show">
                  <img class="hide-show-icon" src="/assets/images/show-password-icon.svg" alt="icon-show" />
                </span>
              </div>
            </div>

            <!-- case with errors -->
            <div *ngIf="f['newPassword'].errors" class="password-validators">
              <div class="validator">
                <div *ngIf="f['newPassword'].errors?.['minlength'] || !f['newPassword'].value">
                  <img src="/assets/images/icon-radio-button-off.svg" alt="icon-radio-button-off" />
                </div>
                <div *ngIf="!f['newPassword'].errors?.['minlength'] && f['newPassword'].value">
                  <img src="/assets/images/icon-green-checkmark-circle.svg" alt="icon-radio-button-on" />
                </div>
                <div
                  [ngClass]="{
                    'validator-text': true,
                    'validator-is-valid': !f['newPassword'].errors?.['minlength'] && f['newPassword'].value,
                  }"
                >
                  {{ 'update-password.validator1' | translate }}
                </div>
              </div>
              <div class="validator">
                <div *ngIf="f['newPassword'].errors?.['hasSpecialCharacters'] || !f['newPassword'].value">
                  <img src="/assets/images/icon-radio-button-off.svg" alt="icon-radio-button-off" />
                </div>
                <div *ngIf="!f['newPassword'].errors?.['hasSpecialCharacters'] && f['newPassword'].value">
                  <img src="/assets/images/icon-green-checkmark-circle.svg" alt="icon-radio-button-on" />
                </div>
                <div
                  [ngClass]="{
                    'validator-text': true,
                    'validator-is-valid': !f['newPassword'].errors?.['hasSpecialCharacters'] && f['newPassword'].value,
                  }"
                >
                  {{ 'update-password.validator2' | translate }}
                </div>
              </div>
              <div class="validator">
                <div *ngIf="f['newPassword'].errors?.['hasSmallCase'] || !f['newPassword'].value">
                  <img src="/assets/images/icon-radio-button-off.svg" alt="icon-radio-button-off" />
                </div>
                <div *ngIf="!f['newPassword'].errors?.['hasSmallCase'] && f['newPassword'].value">
                  <img src="/assets/images/icon-green-checkmark-circle.svg" alt="icon-radio-button-on" />
                </div>
                <div
                  [ngClass]="{
                    'validator-text': true,
                    'validator-is-valid': !f['newPassword'].errors?.['hasSmallCase'] && f['newPassword'].value,
                  }"
                >
                  {{ 'update-password.validator3' | translate }}
                </div>
              </div>
              <div class="validator">
                <div *ngIf="f['newPassword'].errors?.['hasNumber'] || !f['newPassword'].value">
                  <img src="/assets/images/icon-radio-button-off.svg" alt="icon-radio-button-off" />
                </div>
                <div *ngIf="!f['newPassword'].errors?.['hasNumber'] && f['newPassword'].value">
                  <img src="/assets/images/icon-green-checkmark-circle.svg" alt="icon-radio-button-on" />
                </div>
                <div
                  [ngClass]="{
                    'validator-text': true,
                    'validator-is-valid': !f['newPassword'].errors?.['hasNumber'] && f['newPassword'].value,
                  }"
                >
                  {{ 'update-password.validator4' | translate }}
                </div>
              </div>
              <div class="validator">
                <div *ngIf="f['newPassword'].errors?.['hasCapitalCase'] || !f['newPassword'].value">
                  <img src="/assets/images/icon-radio-button-off.svg" alt="icon-radio-button-off" />
                </div>
                <div *ngIf="!f['newPassword'].errors?.['hasCapitalCase'] && f['newPassword'].value">
                  <img src="/assets/images/icon-green-checkmark-circle.svg" alt="icon-radio-button-on" />
                </div>
                <div
                  [ngClass]="{
                    'validator-text': true,
                    'validator-is-valid': !f['newPassword'].errors?.['hasCapitalCase'] && f['newPassword'].value,
                  }"
                >
                  {{ 'update-password.validator5' | translate }}
                </div>
              </div>
            </div>

            <!-- case without errors (Else there an issue because f.password.erros = null -->
            <div *ngIf="!f['newPassword'].errors" class="password-validators">
              <div class="validator">
                <div><img src="/assets/images/icon-green-checkmark-circle.svg" alt="check-ok" /></div>
                <div class="validator-text validator-is-valid">
                  {{ 'update-password.validator1' | translate }}
                </div>
              </div>
              <div class="validator">
                <div><img src="/assets/images/icon-green-checkmark-circle.svg" alt="check-ok" /></div>
                <div class="validator-text validator-is-valid">
                  {{ 'update-password.validator2' | translate }}
                </div>
              </div>
              <div class="validator">
                <div><img src="/assets/images/icon-green-checkmark-circle.svg" alt="check-ok" /></div>
                <div class="validator-text validator-is-valid">
                  {{ 'update-password.validator3' | translate }}
                </div>
              </div>
              <div class="validator">
                <div><img src="/assets/images/icon-green-checkmark-circle.svg" alt="check-ok" /></div>
                <div class="validator-text validator-is-valid">
                  {{ 'update-password.validator4' | translate }}
                </div>
              </div>
              <div class="validator">
                <div><img src="/assets/images/icon-green-checkmark-circle.svg" alt="check-ok" /></div>
                <div class="validator-text validator-is-valid">
                  {{ 'update-password.validator5' | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="confirmPassword" class="login-label-title fw-bold">
              {{ 'update-password.confirm-new-password' | translate | uppercase }}</label
            >

            <div class="input-group">
              <input
                id="confirmPassword"
                [ngClass]="{ 'is-invalid': confirmationPasswordIsWrong() && userLeftInputConfirmPassword }"
                (blur)="userLeftInputConfirmPassword = true"
                (focus)="userLeftInputConfirmPassword = false"
                [type]="fieldTextTypeList[2] ? 'text' : 'password'"
                formControlName="confirmPassword"
                class="form-control"
              />
              <div class="input-group-append-hide-show">
                <span *ngIf="fieldTextTypeList[2]" (click)="toggleFieldTextType(2)" class="hide-show">
                  <img class="hide-show-icon" src="/assets/images/hide-password-icon.svg" />
                </span>
                <span *ngIf="!fieldTextTypeList[2]" (click)="toggleFieldTextType(2)" class="hide-show">
                  <img class="hide-show-icon" src="/assets/images/show-password-icon.svg" />
                </span>
              </div>
            </div>
            <div *ngIf="confirmationPasswordIsWrong() && userLeftInputConfirmPassword" class="error-div">
              <div class="no-match-error-message">
                <img class="no-match-icon" src="/assets/images/icon-alert-triangle.svg" />
                <div class="no-match-text">{{ 'update-password.invalid-confirmation-password' | translate }}</div>
              </div>
            </div>
          </div>

          <div class="login-btn-container form-group">
            <ex-button type="primary" variant="raised" [disabled]="loading || f['newPassword'].invalid || f['confirmPassword'].invalid">
              {{ 'common.save' | translate }}
            </ex-button>
          </div>
        </form>
      </div>
    }
  </div>
</div>
<app-toast-message createMessage="update-password.toast-content"></app-toast-message>
<ng-template #successToast let-content="content">
  <div class="d-flex fw-bolder h-100">
    <img src="assets/images/icon-checkmark-circle.svg" class="align-self-center toast-image" alt="icon-checkmark" />
    <div>{{ content | translate }}</div>
  </div>
</ng-template>
